import React, {Component}        from 'react';
import {connect}                 from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import { Redirect,Link }                    from 'react-router-dom';
import renderFieldTextArea       from '../../../../container/renderFieldTextArea';
import renderField               from '../../../../container/renderField';
import renderFieldSelec          from '../../../../container/renderFieldSelect';
import validate                  from '../../../../service/validade_missoes';
import {SetError}                from '../../../../actions/notificacaoAction';
import {SetCrudsPalavra}         from '../../../../actions/atividadesAction';
import { ActionModal,
         GetListaMenuTopo,
         GetListaSubMenuTopo}      from '../../../../actions/scopoAction';

class DesafioPalavrasForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ati_pal_id       : 0,
            pal_id           : (this.props.pal_id?this.props.pal_id:[this.props.match.params.id1]),
            valMax           : 123,
            countDinamic     : 123,
            valMaxCont       : 350,
            countDinamicCont : 350,
            redirect : false,
            textButton       : 'Adicionar'
        }
    }

    componentWillMount() {

      if(!this.props.pal_id){
        if(this.props.match.params.id2>0){
         this.acaoForm(true);
        }          
      }  
 
      this.props.GetListaMenuTopo([
        {action:true,nome:"Home",link:this.props.menu.home},
        {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
        {action:true,nome:this.props.menu.desafios.jogo.jogo2,link:`${this.props.menu.desafios.desafiobomba}/${this.state.pal_id}`}
       ]);       
      this.props.GetListaSubMenuTopo([]);

    }

    acaoForm(acao){

        const dados = this.props.all_palavras;
        const retorno = dados.filter(elem =>{  return elem.ati_pal_id == this.props.match.params.id2 });

        this.props.initialize({
                                ati_pal_id       : (acao?retorno[0].ati_pal_id:0),
                                ati_per          : (acao?retorno[0].ati_pal_pergunta:""),
                                ati_pal          : (acao?retorno[0].ati_pal_palavra:""),
                                ati_pal_tempo    : (acao?retorno[0].ati_pal_tempo:""),
                                ati_pal_contexto : (acao?retorno[0].ati_pal_contexto:""),
                                
                              });

        this.setState({
                       textButton       : 'Editar',
                       ati_pal_id       : (acao?retorno[0].ati_pal_id:0),
                       countDinamic     : this.state.valMax-retorno[0].ati_pal_pergunta.length,
                       countDinamicCont : this.state.valMaxCont-retorno[0].ati_pal_contexto.length
                     })
    }   

    handleSubmit(e) {

        const form = {
            ati_per          : e.ati_per,
            ati_pal          : e.ati_pal,
            ati_pal_id       : this.state.ati_pal_id,
            ati_pal_tempo    : e.ati_pal_tempo,
            ati_pal_contexto : e.ati_pal_contexto,
            pal_id           : this.state.pal_id
        }

        this.setState({textButton:'Enviando...'})
        this.props.SetCrudsPalavra(form).then((response) => {
            alert('Ação realizada com sucesso!');
            this.setState({textButton: 'Adicionar',countDinamic: this.state.valMax,countDinamicCont: this.state.valMaxCont});
            if(!this.props.pal_id){
              if(this.props.match.params.id2>0){
                this.setState({redirect:true});
             }
            }
        }).catch((error) => {
            this.props.SetError(500);
        });
    }

    countCaractere(e){
      const text_remaning = this.state.valMax - e.target.textLength;
      this.setState({countDinamic:text_remaning})
    }

    countCaractereContexto(e){
        const text_remaning = this.state.valMaxCont - e.target.textLength;
        this.setState({countDinamicCont:text_remaning})
    }

    render() {
        const {handleSubmit} = this.props;
        const listTempo      = [{item:30},{item:60},{item:90},{item:120}].map((elem,i)  => <option key={i} value={elem.value}>{elem.item}</option>);

          if (this.state.redirect) {
            return (<Redirect to={`${this.props.menu.desafios.desafiobomba}/${this.state.pal_id[0]}`}/>);
          }  

        return (
           <div className="container-bg">
           <div className="panel panel-default">
               <div className="panel-body">
                   <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                       <div className="conteudo-pergunta">
                           <span className="count pull-right">{this.state.countDinamicCont && this.state.countDinamicCont}</span>
                           <Field name="ati_pal_contexto" type="textarea" onChange={this.countCaractereContexto.bind(this)} length={this.state.valMaxCont} component={renderFieldTextArea} label="Contexto" />
                        
                       </div>       
                       <div className="conteudo-pergunta">
                       <span className="count pull-right">{this.state.countDinamic && this.state.countDinamic}</span>
                           <Field name="ati_per" type="textarea" length={this.state.valMax} onChange={this.countCaractere.bind(this)} component={renderFieldTextArea} label="Pergunta*" />
                       </div>
                       <Field name="ati_pal" type="text" length="12" component={renderField} label="Palavra*" />
                       <Field name="ati_pal_tempo" label="Tempo do Jogo*" component={renderFieldSelec} option={listTempo}/>
                       <Link  to={`${this.props.menu.desafios.desafiobomba}/${this.state.pal_id[0]}`} className="btn btn-sm btn-primary pull-left">Voltar</Link>
                       <button type="submit" className="btn btn-primary btn-sm pull-right">{this.state.textButton}</button>
                   </form>
               </div>
           </div>
       
       </div>
        );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('forma_bomba'));

function mapStateToProps(state) {

    return {
            menu       : state.configReducer.menu,
            tipo         : state.atividadesReducer.tipo,
            all_palavras : state.atividadesReducer.fetch_all_palavra
           }
}

export default reduxForm(
        {form: 'forma_bomba', 
        destroyOnUnmount: true, 
        forceUnregisterOnUnmount: true, 
        onSubmitSuccess: afterSubmit,  validate})
        (connect(mapStateToProps, {SetCrudsPalavra,
                                   ActionModal,
                                   GetListaMenuTopo,
                                   GetListaSubMenuTopo,
                                   SetError})(DesafioPalavrasForm));






// WEBPACK FOOTER //
// ./src/components/professor/desafios/bomba/desafios_bomba_form.js